module.exports = __webpack_public_path__ + "media/images/web/home/specs/spec_networking_2-09c5b24330919c92bea65f4431549e7a.jpg";